export default __webpack_public_path__ + "static/media/misc-books2-768w.9817e57c.avif";